import type { AnalyticsEventData } from '../types';
import { isAnalyticsHost } from '../hosts';
import { sanitizeEventData, sanitizeEventName } from '../sanitize';

declare global {
  interface Window {
    umami?: {
      track: (
        event: string | AnalyticsEventData | ((props: AnalyticsEventData) => AnalyticsEventData),
        data?: AnalyticsEventData
      ) => void;
    };
  }
}

/** @deprecated Use isAnalyticsHost */
export const isUmamiHost = isAnalyticsHost;

export function trackUmamiEvent(
  event: string,
  data?: AnalyticsEventData
): void {
  if (!isAnalyticsHost()) return;
  const umami = window.umami;
  if (!umami || typeof umami.track !== 'function') return;

  const name = sanitizeEventName(event);
  const payload = sanitizeEventData(data);
  if (payload) {
    umami.track(name, payload);
  } else {
    umami.track(name);
  }
}
